export default "__VITE_ASSET__32a7d40f__"